var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row col-at-sm col-at-md"},[_c('doughnut',{attrs:{"total":_vm.client.seven_day_totals.momentum}},[_vm._v("Momentum")]),_c('doughnut',{attrs:{"total":_vm.client.seven_day_totals.pulse}},[_vm._v("Pulse")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }